import { render, staticRenderFns } from "./GeneralInfoStep.vue?vue&type=template&id=c3470518"
import script from "./GeneralInfoStep.vue?vue&type=script&lang=js"
export * from "./GeneralInfoStep.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports